import { doSignIn, getJWT } from "./providers/jwt";

/**
 * This handles special URLs that are used for direct linking to a document, but using
 * the Okta authentication.  It does this by setting up a cookie then directly
 * requesting the document.
 */
export async function processDirectLink(key: string) {
  console.log("Fetching document link");
  let jwt: string | undefined;
  try {
    jwt = await getJWT();
  } catch (ex) {
    console.log("Error fetching JWT... user must authenticate", ex);
    jwt = undefined;
  }

  if (!jwt) {
    const root = document.getElementById("root") as HTMLElement;
    root.innerHTML = '<div style="margin: 2em;">Redirecting to Sign in</div>';

    // Come back to the same page.
    doSignIn(document.location.toString());
  } else {
    // Set a cookie to be sent with the request
    document.cookie = `MRLDOCS_AUTH=${jwt}; SameSite=Strict; Secure; path=/docs; expires=${new Date(
      Date.now() + 30 * 60 * 1000
    ).toString()};`;
    console.log("Redirecting to real download URL");
    // Change the browser URL to the real document download URL.  The Cookie should be sent
    window.location.replace(key);
  }
}
